export function clamp01(value: number): number {
    if (!Number.isFinite(value)) return 0;
    return Math.max(0, Math.min(1, value));
}

export function clampGapPhaseEnd(value: number | undefined, fallback = 0.6): number {
    const candidate = Number.isFinite(value) ? Number(value) : fallback;
    return Math.max(0.05, Math.min(0.95, candidate));
}

export const LOOP_FORWARD_ANIMATION_DELAY_PHASE = 0.28;

export function toReverseReappearProgress(args: { progress01: number; gapPhaseEnd: number }): number {
    const progress01 = clamp01(args.progress01);
    const gapPhaseEnd = clampGapPhaseEnd(args.gapPhaseEnd);
    if (progress01 <= gapPhaseEnd) return 0;

    const tail = 1 - gapPhaseEnd;
    if (tail <= 1e-9) return 1;
    return clamp01((progress01 - gapPhaseEnd) / tail);
}

export function remapProgressWithWarmup(args: { progress01: number; warmupPhase: number }): number {
    const progress01 = clamp01(args.progress01);
    const warmupPhase = clamp01(args.warmupPhase);
    if (progress01 <= warmupPhase) return 0;

    const tail = 1 - warmupPhase;
    if (tail <= 1e-9) return 1;
    return clamp01((progress01 - warmupPhase) / tail);
}

export function clampPositionIntervalMs(value: number, minPositionIntervalMs: number, fallback = 400): number {
    if (!Number.isFinite(value)) return fallback;
    return Math.max(minPositionIntervalMs, value);
}

export function clampPositionIndex(positionIndex: number, maxPosition: number): number {
    if (!Number.isFinite(positionIndex)) return 0;
    return Math.max(0, Math.min(Math.trunc(positionIndex), maxPosition));
}
